import React from "react";
import DOMPurify from "isomorphic-dompurify";
import {Converter, extension} from "showdown";

extension('underline', function () {
	return {
		type: 'lang',
		regex: /(?:\s|^)(\-\-)(?=\S)([\s\S]+?\S)\1/gm,
		replace: " <u class=\"underline\">$2<\/u>"
	};
});



export const converter = new Converter({
	tables: true,
	simplifiedAutoLink: true,
	strikethrough: true,
	tasklists: true,
	literalMidWordUnderscores: true,
	simpleLineBreaks: true,
	openLinksInNewWindow: true,
	extensions: ['underline']
});


export default function Sanitize({ text, ...rest }) {

	return <div {...rest} dangerouslySetInnerHTML={{
		__html: converter.makeHtml(DOMPurify.sanitize(text, { FORBID_TAGS: ["style"] }))
		}}
	/>
}